import android from "assets/img/tech_stack/android.png";
import swift from "assets/img/tech_stack/swift.png";
import flutter from "assets/img/tech_stack/flutter.png";
import react from "assets/img/tech_stack/icon-react-native.png";
import cordova from "assets/img/tech_stack/cordova.png";
import kotlin from "assets/img/tech_stack/kotlin.png";

const textProps = {
  heading3: {
    title: "Mobile",
    alignment: "center",
  },

  infoAreas: [
    {
      image: android,
      name: "Android",
    },
    {
      image: swift,
      name: "Swift",
    },
    {
      image: flutter,
      name: "Flutter",
    },
    {
      image: react,
      name: "React Native",
    },
    {
      image: cordova,
      name: "Cordova",
    },
    {
      image: kotlin,
      name: "Kotlin",
    },
  ],
};
export default textProps;
